module.exports = __webpack_public_path__ + "img/logo.77a468d4.png";